export default __webpack_public_path__ + "images/f603712922f487ec1dec4325c5d9cd52-christmas_small.webp";